import React from 'react';
import type { InvoiceStatus } from '../../types/invoice';
const styles: Record<InvoiceStatus | 'Forfalden', string> = {
  Kladde: 'border-line bg-canvas text-ink-soft',
  'Klar til afsendelse': 'border-accent/40 bg-accent-soft text-accent-deep',
  Sendt: 'border-ink/20 bg-ink text-white',
  Betalt: 'border-line bg-white text-ink',
  Annulleret: 'border-line bg-canvas text-ink-muted',
  Forfalden: 'border-danger/40 bg-danger/10 text-danger'
};
export function InvoiceStatusBadge({
  status
}: {
  status: InvoiceStatus | 'Forfalden';
}) {
  return <span className={`inline-flex shrink-0 items-center whitespace-nowrap rounded-full border px-2.5 py-1 text-xs font-medium ${styles[status]}`} data-id="element-149" data-mp="30w96hifihhsy">
      {status}
    </span>;
}